/*
Monotype Foundry Platform API
Version 1.0.0

Definition: PaymentRequest

Properties:
  addressSection: object
  createdAt: string
  id: string
  paymentMethodSection: object
  paymentRevisionId: string
  setupHistory: array
  taxInfoSection: object
  updatedAt: string
  userId: string
  vendorId: string
*/

var PaymentRequest = (function () {
  function validatePaymentRequest (arg) {
    // Validate addressSection
    if (arg.addressSection && !(typeof arg.addressSection === 'object')) {
      throw new Error('PaymentRequest.addressSection: Wrong type: Got \'' + (typeof arg.addressSection) + '\', but expected: \'object\'')
    }
    // Validate paymentMethodSection
    if (arg.paymentMethodSection && !(typeof arg.paymentMethodSection === 'object')) {
      throw new Error('PaymentRequest.paymentMethodSection: Wrong type: Got \'' + (typeof arg.paymentMethodSection) + '\', but expected: \'object\'')
    }
    // Validate taxInfoSection
    if (arg.taxInfoSection && !(typeof arg.taxInfoSection === 'object')) {
      throw new Error('PaymentRequest.taxInfoSection: Wrong type: Got \'' + (typeof arg.taxInfoSection) + '\', but expected: \'object\'')
    }
    // Validate userId
    if (arg.userId && !(typeof arg.userId === 'string')) {
      throw new Error('PaymentRequest.userId: Wrong type: Got \'' + (typeof arg.userId) + '\', but expected: \'string\'')
    }
    // Validate vendorId
    if (arg.vendorId && !(typeof arg.vendorId === 'string')) {
      throw new Error('PaymentRequest.vendorId: Wrong type: Got \'' + (typeof arg.vendorId) + '\', but expected: \'string\'')
    }
  }
  function buildPaymentRequest (arg) {
    var PaymentRequest = arg
    // Complete addressSection
    // Expected Type: object
    PaymentRequest.addressSection = PaymentRequest.addressSection || {}
    // Complete addressSection.address1
    // Expected Type: string
    PaymentRequest.addressSection.address1 = PaymentRequest.addressSection.address1 || ''
    // Complete addressSection.address2
    // Expected Type: string
    PaymentRequest.addressSection.address2 = PaymentRequest.addressSection.address2 || ''
    // Complete addressSection.city
    // Expected Type: string
    PaymentRequest.addressSection.city = PaymentRequest.addressSection.city || ''
    // Complete addressSection.country
    // Expected Type: object
    PaymentRequest.addressSection.country = PaymentRequest.addressSection.country || {}
    // Complete addressSection.email
    // Expected Type: string
    PaymentRequest.addressSection.email = PaymentRequest.addressSection.email || ''
    // Complete addressSection.legalName
    // Expected Type: string
    PaymentRequest.addressSection.legalName = PaymentRequest.addressSection.legalName || ''
    // Complete addressSection.phone
    // Expected Type: string
    PaymentRequest.addressSection.phone = PaymentRequest.addressSection.phone || ''
    // Complete addressSection.state
    // Expected Type: object
    PaymentRequest.addressSection.state = PaymentRequest.addressSection.state || {}
    // Complete addressSection.zipCode
    // Expected Type: string
    PaymentRequest.addressSection.zipCode = PaymentRequest.addressSection.zipCode || ''
    // Complete paymentMethodSection
    // Expected Type: object
    PaymentRequest.paymentMethodSection = PaymentRequest.paymentMethodSection || {}
    // Complete paymentMethodSection.bankInfo
    // Expected Type: object
    PaymentRequest.paymentMethodSection.bankInfo = PaymentRequest.paymentMethodSection.bankInfo || {}
    // Complete paymentMethodSection.intermediaryBankInfo
    // Expected Type: object
    PaymentRequest.paymentMethodSection.intermediaryBankInfo = PaymentRequest.paymentMethodSection.intermediaryBankInfo || {}
    // Complete paymentMethodSection.minimumPaymentAmount
    // Expected Type: string
    PaymentRequest.paymentMethodSection.minimumPaymentAmount = PaymentRequest.paymentMethodSection.minimumPaymentAmount || ''
    // Complete paymentMethodSection.payPalEmail
    // Expected Type: string
    PaymentRequest.paymentMethodSection.payPalEmail = PaymentRequest.paymentMethodSection.payPalEmail || ''
    // Complete paymentMethodSection.paymentMethod
    // Expected Type: string
    PaymentRequest.paymentMethodSection.paymentMethod = PaymentRequest.paymentMethodSection.paymentMethod || ''
    // Complete taxInfoSection
    // Expected Type: object
    PaymentRequest.taxInfoSection = PaymentRequest.taxInfoSection || {}
    // Complete taxInfoSection.einTin
    // Expected Type: string
    PaymentRequest.taxInfoSection.einTin = PaymentRequest.taxInfoSection.einTin || ''
    // Complete taxInfoSection.ssn
    // Expected Type: string
    PaymentRequest.taxInfoSection.ssn = PaymentRequest.taxInfoSection.ssn || ''
    // Complete userId
    // Expected Type: string
    PaymentRequest.userId = PaymentRequest.userId || ''
    // Complete vendorId
    // Expected Type: string
    PaymentRequest.vendorId = PaymentRequest.vendorId || ''
    return PaymentRequest
  }
  return {
    validate: validatePaymentRequest,
    build: buildPaymentRequest
  }
})()

module.exports = PaymentRequest
